import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_squad_agent_link_RowClass} from "../../../../dbschema";

export class SquadAgentContainerModel extends BaseContainerModel{
  bl_alg_cc_squad_agent_link: bl_alg_cc_squad_agent_link_RowClass = new bl_alg_cc_squad_agent_link_RowClass();
}
